// assets/hat-customizer.js
(() => {
  const ROOT_SEL = '[data-hat-customization]';

  const SEL = {
    root: ROOT_SEL,
    modal: '[data-hat-modal]',
    open: '[data-hat-open]',
    close: '[data-hat-close]',
    brandingInput: '[data-hat-branding-input]',
    brandingBtn: '[data-branding]',
    propBranding: '[data-prop-branding]',

    codesToggle: '[data-hat-codes-toggle]',
    codesPanel: '[data-hat-codes]',

    step: (n) => `[data-hat-step="${n}"]`,
    stepError: '[data-hat-step-error]',

    next: '[data-hat-next]',
    prev: '[data-hat-prev]',

    presetAtc: '[data-hat-modal-atc-preset]',
    step1Next: '[data-step1-next]',

    shapingBtn: '[data-shaping]',
    crownBtn: '[data-crown]',
    brimBtn: '[data-brim]',
    dipBtn: '[data-dip]',
    patchBtn: '[data-patch]',

    propShaping: '[data-prop-shaping]',
    propCrown: '[data-prop-crown]',
    propBrim: '[data-prop-brim]',
    propDip: '[data-prop-dip]',
    propPatch: '[data-prop-patch]',

    overlayImg: '[data-preview="overlay"]',
    mapsScript: '[data-hat-image-maps]',

    modalAtc: '[data-hat-modal-atc]'
  };

  const qs = (root, sel) => root.querySelector(sel);
  const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

  function getFormId(root) {
    return root.getAttribute('data-product-form-id') || '';
  }

  function getShapingValue(root) {
    return (qs(root, SEL.propShaping)?.value || '').trim();
  }

  function isCustom(root) {
    return getShapingValue(root).toLowerCase() === 'custom shape';
  }

  function isJuany(root) {
    return getShapingValue(root).toLowerCase() === 'juany yasmin shape';
  }

  function isNoShaping(root) {
    return getShapingValue(root).toLowerCase() === 'no shaping';
  }

  function setValue(root, inputSel, val) {
    const input = qs(root, inputSel);
    if (!input) return;
    input.value = val || '';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getValue(root, inputSel) {
    return (qs(root, inputSel)?.value || '').trim();
  }

  function setActive(root, btn, groupSel) {
    qsa(root, groupSel).forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  }

  function clearGroup(root, group) {
    const map = {
      crown: { btnSel: SEL.crownBtn, inputSel: SEL.propCrown },
      brim:  { btnSel: SEL.brimBtn,  inputSel: SEL.propBrim },
      dip:   { btnSel: SEL.dipBtn,   inputSel: SEL.propDip },
      patch: { btnSel: SEL.patchBtn, inputSel: SEL.propPatch }
    };
    const cfg = map[group];
    if (!cfg) return;
    qsa(root, cfg.btnSel).forEach((b) => b.classList.remove('is-active'));
    setValue(root, cfg.inputSel, '');
  }

  function showStep(root, n) {
  [1, 2, 3, 4, 5, 6].forEach((i) => {
    const el = qs(root, SEL.step(i));
    if (el) el.hidden = i !== n;

    // Show/hide matching actions panel
    const actions = root.querySelector(`[data-hat-step-actions="${i}"]`);
    if (actions) actions.hidden = i !== n;
  });

  // Restore hat preview when leaving step 5
  if (n !== 5) restoreHatPreview(root);

  root.setAttribute('data-active-step', String(n));
  hideError(root);
  updateStep1Actions(root);
  updateModalATC(root);
}

  function openModal(root) {
    const modal = qs(root, SEL.modal);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    showStep(root, 1);
  }

  function closeModal(root) {
    const modal = qs(root, SEL.modal);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    hideError(root);
  }

  function showError(root, msg) {
    const box = qs(root, SEL.stepError);
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
  }

  function hideError(root) {
    const box = qs(root, SEL.stepError);
    if (!box) return;
    box.textContent = '';
    box.hidden = true;
  }

  function parseMaps(root) {
    const el = qs(root, SEL.mapsScript);
    if (!el) return {};
    try {
      const data = JSON.parse(el.textContent || '{}');
      const norm = {};
      ['shaping', 'crown', 'brim', 'dip'].forEach((k) => {
        const v = data?.[k];
        if (!v) return;
        if (typeof v === 'string') {
          try { norm[k] = JSON.parse(v); } catch { norm[k] = {}; }
        } else if (typeof v === 'object') {
          norm[k] = v;
        }
      });
      return norm;
    } catch {
      return {};
    }
  }

  function setOverlay(root, url) {
    const img = qs(root, SEL.overlayImg);
    if (!img) return;
    if (!url) {
      img.removeAttribute('src');
      img.style.opacity = '0';
      return;
    }
    img.src = url;
    img.style.opacity = '1';
  }

  function updatePreviewFromSelection(root, maps) {
    const dip = getValue(root, SEL.propDip);
    const brim = getValue(root, SEL.propBrim);
    const crown = getValue(root, SEL.propCrown);
    const shaping = getValue(root, SEL.propShaping);

    const tryGet = (group, key) => {
      const m = maps?.[group];
      if (!m || !key) return '';
      return m[key] || m[key.toLowerCase?.()] || '';
    };

    const url =
      tryGet('dip', dip) ||
      tryGet('brim', brim) ||
      tryGet('crown', crown) ||
      tryGet('shaping', shaping) ||
      '';

    setOverlay(root, url);
  }

  function updateStep1Actions(root) {
    const nextBtn = qs(root, SEL.step1Next);
    const presetAtc = qs(root, SEL.presetAtc);
    const shaping = getValue(root, SEL.propShaping).toLowerCase();

    if (nextBtn) {
      nextBtn.hidden = false;
      nextBtn.disabled = !shaping;
      nextBtn.setAttribute('aria-disabled', String(nextBtn.disabled));
    }

    // Preset ATC no longer used — hide it if it exists
    if (presetAtc) {
      presetAtc.hidden = true;
      presetAtc.disabled = true;
    }
  }

  function applyJuanyPresetFromButton(root, btn) {
    const crown = btn.getAttribute('data-preset-crown') || '';
    const brim = btn.getAttribute('data-preset-brim') || '';
    const dip = btn.getAttribute('data-preset-dip') || '';
    setValue(root, SEL.propCrown, crown);
    setValue(root, SEL.propBrim, brim);
    setValue(root, SEL.propDip, dip);
  }

  function updateModalATC(root) {
    const btnFinal = qs(root, SEL.modalAtc);
    const shaping = getValue(root, SEL.propShaping).toLowerCase();

    const crown = getValue(root, SEL.propCrown);
    const brim = getValue(root, SEL.propBrim);
    const dip = getValue(root, SEL.propDip);
    const patchInputExists = !!qs(root, SEL.propPatch);
    const patch = patchInputExists ? getValue(root, SEL.propPatch) : '';

    if (btnFinal) {
      if (shaping === 'custom shape') {
        btnFinal.disabled = patchInputExists
          ? !(crown && brim && dip && patch)
          : !(crown && brim && dip);
      } else if (shaping === 'juany yasmin shape' || shaping === 'wendy ortiz shape' || shaping === 'no shaping' || shaping === 'la comadre lulu shape') {
        // Only require patch for these flows
        btnFinal.disabled = patchInputExists ? !patch : false;
      } else {
        btnFinal.disabled = true;
      }
    }
  }

  function restoreHatPreview(root) {
    const baseImg = qs(root, '[data-preview="base"]');
    if (!baseImg) return;
    const original = root.getAttribute('data-base-img-src');
    const originalAlt = root.getAttribute('data-base-img-alt');
    if (original) {
      baseImg.src = original;
      baseImg.alt = originalAlt || '';
      baseImg.removeAttribute('data-patch-active');
    }
  }

  function validateStep(root, stepNum) {
    const shaping = getValue(root, SEL.propShaping);
    const shapingLower = shaping.toLowerCase();
    const isCustomShape = shapingLower === 'custom shape';
    const patchInputExists = !!qs(root, SEL.propPatch);
    const patch = patchInputExists ? getValue(root, SEL.propPatch) : '';

    if (stepNum === 1) {
      if (!shaping) return 'Please choose a shaping option.';
      return '';
    }

    if (stepNum === 2 && isCustomShape && !getValue(root, SEL.propCrown)) {
      return 'Please choose a crown option.';
    }
    if (stepNum === 3 && isCustomShape && !getValue(root, SEL.propBrim)) {
      return 'Please choose a brim option.';
    }
    if (stepNum === 4 && isCustomShape && !getValue(root, SEL.propDip)) {
      return 'Please choose a dip option.';
    }
    if (stepNum === 5 && patchInputExists && !patch) {
      return 'Please choose a free patch.';
    }

    return '';
  }

  function submitRealProductForm(root) {
      const formId = getFormId(root);
      if (!formId) {
        console.error('[Hat Customizer] Missing data-product-form-id on root');
        return false;
      }

      const form = document.getElementById(formId);
      if (!form) {
        console.error('[Hat Customizer] Could not find product form with id:', formId);
        return false;
      }

      const brandingVal = getValue(root, SEL.propBranding).trim();
      const hasBranding = brandingVal.length > 0 && brandingVal.toLowerCase() !== 'no branding';
      const addonVariantId = root.getAttribute('data-branding-addon-variant-id');

      const submitBtn =
        form.querySelector('button[name="add"][type="submit"]') ||
        form.querySelector('button[data-add-to-cart]') ||
        form.querySelector('button.btn--submit') ||
        form.querySelector('button[type="submit"]');

      function doSubmit() {
        try {
          if (submitBtn && form.requestSubmit) {
            form.requestSubmit(submitBtn);
          } else if (form.requestSubmit) {
            form.requestSubmit();
          } else if (submitBtn) {
            submitBtn.click();
          } else {
            form.submit();
          }
          return true;
        } catch (err) {
          console.error('[Hat Customizer] submit failed:', err);
          return false;
        }
      }

      // Add branding add-on FIRST, then submit main product
      if (hasBranding && addonVariantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(addonVariantId, 10),
                quantity: 1,
                properties: {
                  'For Hat': root.getAttribute('data-parent-product-title') || '',
                  'Branding Design': brandingVal
                }
              }
            ]
          })
        })
        .then((res) => res.json())
        .then(() => {
          doSubmit();
        })
        .catch((err) => {
          console.error('[Hat Customizer] Failed to add branding add-on:', err);
          // Still submit main product even if add-on fails
          doSubmit();
        });

        return true;
      }

      // No branding — submit normally
      return doSubmit();
    }

  function init(root) {
    const maps = parseMaps(root);

    // Cache the original hat preview src for restoring after patch preview
    const baseImg = qs(root, '[data-preview="base"]');
    if (baseImg) {
      root.setAttribute('data-base-img-src', baseImg.src);
      root.setAttribute('data-base-img-alt', baseImg.alt);
    }

    // Open/close
    qs(root, SEL.open)?.addEventListener('click', () => openModal(root));
    qs(root, SEL.close)?.addEventListener('click', () => closeModal(root));

    // Next buttons
    qsa(root, SEL.next).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (btn.disabled) {
          e.preventDefault();
          return;
        }
        e.preventDefault();

        const current = parseInt(root.getAttribute('data-active-step') || '1', 10);
        const msg = validateStep(root, current);
        if (msg) return showError(root, msg);

        // Auto-skip steps 2–4 for Juany and No Shaping
        const shaping = getValue(root, SEL.propShaping).toLowerCase();
        const skipMiddle = shaping === 'juany yasmin shape' || shaping === 'wendy ortiz shape' || shaping === 'no shaping' || shaping === 'la comadre lulu shape';

        let next = parseInt(btn.getAttribute('data-next') || String(current + 1), 10);

        if (skipMiddle && current === 1) {
          next = 5;
        }

        showStep(root, Math.min(6, Math.max(1, next)));
      });
    });

    // Prev buttons
    qsa(root, SEL.prev).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const shaping = getValue(root, SEL.propShaping).toLowerCase();
        const skipMiddle = shaping === 'juany yasmin shape' || shaping === 'wendy ortiz shape' || shaping === 'no shaping' || shaping === 'la comadre lulu shape';

        let prev = parseInt(btn.getAttribute('data-prev') || '1', 10);

        // If they're on step 5 and hit Back, skip straight to step 1
        const current = parseInt(root.getAttribute('data-active-step') || '1', 10);
        if (skipMiddle && current === 5) {
          prev = 1;
        }

        showStep(root, Math.min(6, Math.max(1, prev)));
      });
    });

    // STEP 1: shaping selection
    qsa(root, SEL.shapingBtn).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const val = (btn.getAttribute('data-shaping') || btn.textContent.trim()).trim();
        setActive(root, btn, SEL.shapingBtn);
        setValue(root, SEL.propShaping, val);

        clearGroup(root, 'crown');
        clearGroup(root, 'brim');
        clearGroup(root, 'dip');
        clearGroup(root, 'patch');

        const lower = val.toLowerCase();

        if (lower === 'juany yasmin shape') {
          applyJuanyPresetFromButton(root, btn);
        }

        updatePreviewFromSelection(root, maps);
        updateStep1Actions(root);
        updateModalATC(root);
        hideError(root);
      });
    });

    // STEP 2: crown selection
    qsa(root, SEL.crownBtn).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!isCustom(root)) return;

        const val = btn.getAttribute('data-crown') || btn.textContent.trim();
        setActive(root, btn, SEL.crownBtn);
        setValue(root, SEL.propCrown, val);

        clearGroup(root, 'brim');
        clearGroup(root, 'dip');
        clearGroup(root, 'patch');

        updatePreviewFromSelection(root, maps);
        updateModalATC(root);
        hideError(root);
      });
    });

    // STEP 3: brim selection
    qsa(root, SEL.brimBtn).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!isCustom(root)) return;

        const val = btn.getAttribute('data-brim') || btn.textContent.trim();
        setActive(root, btn, SEL.brimBtn);
        setValue(root, SEL.propBrim, val);

        clearGroup(root, 'dip');
        clearGroup(root, 'patch');

        updatePreviewFromSelection(root, maps);
        updateModalATC(root);
        hideError(root);
      });
    });

    // STEP 4: dip selection
    qsa(root, SEL.dipBtn).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!isCustom(root)) return;

        const val = btn.getAttribute('data-dip') || btn.textContent.trim();
        setActive(root, btn, SEL.dipBtn);
        setValue(root, SEL.propDip, val);

        clearGroup(root, 'patch');

        updatePreviewFromSelection(root, maps);
        updateModalATC(root);
        hideError(root);
      });
    });

    // Allow all shaping types to select a patch
    // STEP 5: patch selection
    qsa(root, SEL.patchBtn).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const val = (btn.getAttribute('data-patch') || btn.textContent.trim()).trim();
        setActive(root, btn, SEL.patchBtn);
        setValue(root, SEL.propPatch, val);

        // Swap preview panel image with patch image if available
        const imgUrl = btn.getAttribute('data-patch-img');
        const baseImg = qs(root, '[data-preview="base"]');

        if (baseImg) {
          if (imgUrl) {
            baseImg.src = imgUrl;
            baseImg.alt = val;
            baseImg.setAttribute('data-patch-active', 'true');
          } else {
            // Text-only patch — restore hat image
            restoreHatPreview(root);
          }
        }

        updateModalATC(root);
        hideError(root);
      });
    });

    // STEP 6: branding button (No Branding)
    qsa(root, SEL.brandingBtn).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const val = (btn.getAttribute('data-branding') || btn.textContent.trim()).trim();
        setActive(root, btn, SEL.brandingBtn);
        setValue(root, SEL.propBranding, val);

        const input = qs(root, SEL.brandingInput);
        if (input) input.value = '';

        updateModalATC(root);
        hideError(root);
      });
    });

    // Branding chart toggle
    qs(root, SEL.codesToggle)?.addEventListener('click', (e) => {
      e.preventDefault();
      const panel = qs(root, SEL.codesPanel);
      if (!panel) return;

      const isOpen = !panel.hidden;
      panel.hidden = isOpen;
      e.currentTarget.textContent = isOpen
        ? 'View branding design codes'
        : 'Hide branding design codes';
    });

    // Preset ATC (kept for safety but hidden via updateStep1Actions)
    qs(root, SEL.presetAtc)?.addEventListener('click', (e) => {
      e.preventDefault();
      updateModalATC(root);
      const btn = qs(root, SEL.presetAtc);
      if (btn?.disabled) return;
      const ok = submitRealProductForm(root);
      if (ok) closeModal(root);
      else showError(root, 'Could not submit the product form.');
    });

    // Final ATC
    qs(root, SEL.modalAtc)?.addEventListener('click', (e) => {
      e.preventDefault();

      const current = parseInt(root.getAttribute('data-active-step') || '1', 10);
      const msg = validateStep(root, current);
      if (msg) return showError(root, msg);

      updateModalATC(root);
      const btn = qs(root, SEL.modalAtc);
      if (btn?.disabled) return;

      const ok = submitRealProductForm(root);
      if (ok) closeModal(root);
      else showError(root, 'Could not submit the product form.');
    });


    // Initial state
    updatePreviewFromSelection(root, maps);
    updateStep1Actions(root);
    updateModalATC(root);
  }

  function clearBrandingActive(root) {
    qsa(root, SEL.brandingBtn).forEach((b) => b.classList.remove('is-active'));
  }

  function boot() {
    const roots = document.querySelectorAll(SEL.root);
    if (!roots.length) return;
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

(function () {
  function applyNoShapingDefaults(container) {
    const shaping  = container.querySelector('[data-prop-shaping]');
    const crown    = container.querySelector('[data-prop-crown]');
    const brim     = container.querySelector('[data-prop-brim]');
    const dip      = container.querySelector('[data-prop-dip]');
    const patch    = container.querySelector('[data-prop-patch]');
    const branding = container.querySelector('[data-prop-branding]');
    const notice   = container.querySelector('[data-hat-quick-buy-notice]');
    const trigger  = container.querySelector('[data-hat-open]');

    if (shaping)  shaping.value  = 'No Shaping';
    if (crown)    crown.value    = '';
    if (brim)     brim.value     = '';
    if (dip)      dip.value      = '';
    if (patch)    patch.value    = 'No Patch';
    if (branding) branding.value = 'No Branding';

    if (notice)  notice.style.display = 'block';
    if (trigger) trigger.style.display = 'none';

    console.log('[Hat QB] No Shaping defaults applied to quick-buy drawer');
  }

  // Track whether the LAST quick-view trigger was a quick-buy button
  let lastWasQuickBuy = false;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-button-quick-view]');
    lastWasQuickBuy = !!btn;
    if (btn) console.log('[Hat QB] Quick-buy click detected');
  }, true); // capture phase so we catch it before the drawer opens

  const observer = new MutationObserver(function (mutations) {
    if (!lastWasQuickBuy) return;

    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;

        // Check the node itself and all descendants
        const candidates = [];
        if (node.matches && node.matches('[data-hat-customization]')) {
          candidates.push(node);
        }
        node.querySelectorAll && node.querySelectorAll('[data-hat-customization]').forEach(n => candidates.push(n));

        for (const customizer of candidates) {
          applyNoShapingDefaults(customizer);
          lastWasQuickBuy = false; // reset after applying
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  console.log('[Hat QB] Quick-buy observer active');
})();